import { render, staticRenderFns } from "./ChannelMediaTypeCategories.vue?vue&type=template&id=070526dd&scoped=true&"
import script from "./ChannelMediaTypeCategories.vue?vue&type=script&lang=js&"
export * from "./ChannelMediaTypeCategories.vue?vue&type=script&lang=js&"
import style0 from "./ChannelMediaTypeCategories.vue?vue&type=style&index=0&id=070526dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070526dd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChannelsCategoriesListItem: require('/opt/render/project/src/channels2022/src/components/channels/ChannelsCategoriesListItem.vue').default})
